import { ArrowLeftIcon, ArrowRightIcon } from '@phosphor-icons/react'

/**
 * The one-at-a-time flows' primary motion, flanking the card. Moving on
 * without acting keeps the contact's place in the queue, so these read as
 * plain navigation. Hidden below `md`, where an under-card row carries the
 * same two actions.
 */
export function NavArrow({
  direction,
  onClick,
  disabled,
}: {
  direction: `prev` | `next`
  onClick: () => void
  disabled?: boolean
}) {
  const isNext = direction === `next`
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={isNext ? `Next contact` : `Previous contact`}
      className="group hidden shrink-0 flex-col items-center gap-2 md:flex"
    >
      <span className="flex h-14 w-14 items-center justify-center rounded-full border border-default bg-surface text-subtle shadow-elevation-1 transition group-hover:border-strong group-hover:text-strong group-hover:shadow-elevation-2 group-active:scale-95 group-disabled:border-default group-disabled:text-minimal group-disabled:shadow-none">
        {isNext ? <ArrowRightIcon size={24} weight="bold" /> : <ArrowLeftIcon size={24} weight="bold" />}
      </span>
      <span className="text-body-xs text-subtle transition group-hover:text-default group-disabled:text-minimal">
        {isNext ? `Next` : `Previous`}
      </span>
    </button>
  )
}
